import axiosInstance from "../../../api/axiosInstance";

let deleteSpace = async(id, user) => {
    return new Promise((resolve, reject) => {    
        axiosInstance.delete(process.env.REACT_APP_API + "/espacios/delete/" + id + "/" + user?.profile + "/" + user?.locale)
        .then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default deleteSpace